import { atom } from 'jotai'

import { allKey, type CountColumnKey } from '../utils'

import { tabulatedColumnCustomerAttributeIdsAtom } from './queryAtoms'

export const countColumnKeysAtom = atom<CountColumnKey[]>((get) => [
  allKey,
  ...get(tabulatedColumnCustomerAttributeIdsAtom),
])
